import { makeAutoObservable } from "mobx";

export interface AccessPropApi {
  accessId: string;
  userMail: string;
  learningPathId: string;
  numGroups: number;
  numStudentsInGroup: number;
  accessTimeInMonths: number;
}

export class StartAccessData implements AccessPropApi {
  accessId: string = "";
  userMail: string = "";
  learningPathId: string = "";
  numGroups: number = 1;
  numStudentsInGroup: number = 12;
  accessTimeInMonths: number = 1;
}

export class ObservableAccessPropImpl implements AccessPropApi {
  accessId: string;
  userMail: string;
  learningPathId: string;
  numGroups: number;
  numStudentsInGroup: number;
  accessTimeInMonths: number;

  constructor(access: AccessPropApi) {
    this.accessId = access.accessId;
    this.userMail = access.userMail;
    this.learningPathId = access.learningPathId;
    this.numGroups = access.numGroups;
    this.numStudentsInGroup = access.numStudentsInGroup;
    this.accessTimeInMonths = access.accessTimeInMonths;
    makeAutoObservable(this);
  }

  onChangeUserMail = (userMail: string) => {
    this.userMail = userMail;
  };

  onChangeLearningPathId = (learningPathId: string) => {
    this.learningPathId = learningPathId;
  };

  onChangeNumGroups = (numGroups: number) => {
    this.numGroups = numGroups;
  };

  onChangeNumStudentsInGroup = (numStudentsInGroup: number) => {
    this.numStudentsInGroup = numStudentsInGroup;
  };

  onChangeAccessTimeInMonths = (accessTimeInMonths: number) => {
    this.accessTimeInMonths = accessTimeInMonths;
  };
}
